<template >
  <nav class="navbar navbar-dark bg-dark fixed-top">
    <div class="container-fluid">
      <router-link class="navbar-brand" active-class="selected" to="/">
        <TerminalSimulator referrer="topnavigation.title" text="Azad Barkho"/>
      </router-link>

      <div class="pages-links">
        <router-link class="nav-desktop-el" active-class="selected" to="/">
          Start
        </router-link>
        <router-link class="nav-desktop-el" active-class="selected" to="/about">
          Über&nbsp;mich
        </router-link>
        <router-link class="nav-desktop-el" active-class="selected" to="/projects">
          Projekte
        </router-link>
        <router-link class="nav-desktop-el" active-class="selected" to="/contact">
          Kontakt
        </router-link>
      </div>
      <div class="place-holder"></div>

      <button 
        class="navbar-toggler" 
        type="button" 
        data-bs-toggle="offcanvas" 
        data-bs-target="#offcanvasDarkNavbar" 
        aria-controls="offcanvasDarkNavbar" 
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div 
        class="offcanvas offcanvas-end text-bg-dark" 
        tabindex="-1" 
        id="offcanvasDarkNavbar" 
        aria-labelledby="offcanvasDarkNavbarLabel"
      >
        <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="offcanvasDarkNavbarLabel">Azad Barkho</h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body">
          <ul class="navbar-nav justify-content-end flex-grow-1 pe-3">
            
            <li class="nav-item" @click="closeOffcanvas">
              <router-link to="/" class="nav-link" active-class="active">Start</router-link>
            </li>
            <li class="nav-item" @click="closeOffcanvas">
              <router-link to="/about" class="nav-link" active-class="active">Über&nbsp;mich</router-link>
            </li>
            <li class="nav-item" @click="closeOffcanvas">
              <router-link to="/projects" class="nav-link" active-class="active">Projekte</router-link>
            </li>
            <li class="nav-item" @click="closeOffcanvas">
              <router-link to="/contact" class="nav-link" active-class="active">Kontakt</router-link>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { nextTick } from 'vue';
import TerminalSimulator from './TerminalSimulator.vue';
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle';

export default {
  props: {
    title: String,
    items: Array
  },
  components: {
    TerminalSimulator
  },
  data() {
    return {
      offcanvas: null,
      selected: null
    };
  },
  async mounted() {
    await nextTick();// Sicherstellen, dass das DOM vollständig gerendert ist.
    // Greife auf das DOM-Element zu, wenn die Komponente gemountet ist
    this.offcanvas = new bootstrap.Offcanvas(document.getElementById("offcanvasDarkNavbar"));
  },
  methods: {
    closeOffcanvas() {
      console.log(this.offcanvas)
      if (this.offcanvas) {
        this.offcanvas.hide();
      }
    }
  }
};
</script>

<style scoped>
.pages-links{
  color: white;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-weight: bold;

  .nav-desktop-el{
    border-radius: 5px;
    padding: 5px 15px;
    &:hover{
      background-color: rgba(125, 212, 75, 0.3);
      box-shadow: 0 0 10px rgba(125, 212, 75, 0.5);
    }
    &.selected{
      background-color: rgba(125, 212, 75, 0.3);
      box-shadow: 0 0 10px rgba(125, 212, 75, 0.5);
    }
  }
}

.container-fluid{
  justify-content: space-between;
  align-items: center;
}
.navbar-brand{
  width: 150px;
}

@media screen and (max-width: 768px) {
  .pages-links{
    visibility: hidden;
    width: 0%;
  }
  .navbar-toggler{
    visibility: visible;
  }
}

@media screen and (min-width: 768px) {
  .pages-links{
    visibility: visible;
    width: 50%;
  }
  .navbar-toggler{
    visibility: hidden;
  }
}
</style>